module.exports = __webpack_public_path__ + "static/media/CARD_GOLD@3x.9c9abd85.png";